/**
 * Chess tournament (round-robin, swiss, etc.) – round start and status.
 * Pairing/game creation is handled by nest-brc TournamentModule.
 */
import http from './api'

export interface TournamentStatus {
  tournamentType: string
  nextRound: number
  totalRounds: number
}

export interface Pairing {
  player1Id: string
  player2Id: string
  round: number
}

class ChessTournamentService {
  async getStatus(roomId: string): Promise<TournamentStatus> {
    const response = await http.get(`/chess-tournament/${roomId}/status`)
    return response.data
  }

  async startRound(
    roomId: string,
    round: number,
    options?: { timeControl?: string; variant?: string; rated?: boolean }
  ): Promise<{ message: string; pairings: number; gamesCreated: number }> {
    const response = await http.post(`/chess-tournament/${roomId}/round/${round}/start`, options ?? {})
    return response.data
  }

  async getPairings(roomId: string, round: number): Promise<{ round: number; pairings: Pairing[] }> {
    const response = await http.get(`/chess-tournament/${roomId}/round/${round}/pairings`)
    return response.data
  }
}

const chessTournamentService = new ChessTournamentService()
export default chessTournamentService
